import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatapassService {

  public province_list = [
    "ອັດຕະປື",
    "ບໍ່ແກ້ວ",
    "ບໍລິຄຳໄຊ",
    "ຈຳປາສັກ",
    "ຫົວພັນ",
    "ຄຳມ່ວນ",
    "ຫຼວງນ້ຳທາ",
    "ຫຼວງພະບາງ",
    "ອຸດົມໄຊ",
    "ຜົ້ງສາລີ",
    "ສາລະວັນ",
    "ສະຫວັນນະເຂດ",
    "ເຊກອງ",
    "ວຽງຈັນ",
    "ນະຄອນຫຼວງວຽງຈັນ",
    "ໄຊຍະບູລີ",
    "ຊຽງຂວາງ",
    "ໄຊສົມບູນ"
  ]

  public district = [
    ["ໄຊເສດຖາ", "ສາມັກຄີໄຊ", "ສະໜາມໄຊ", "ສານໄຊ", "ພູວົງ"],
    ["ຫ້ວຍຊາຍ", "ຕົ້ນເຜິ້ງ", "ເມິງ", "ຜາອຸດົມ", "ປາກທາ"],
    ["ປາກຊັນ", "ທ່າພະບາດ", "ປາກກະດິງ", "ບໍລິຄັນ", "ຄຳເກີດ", "ໄຊຈຳພອນ", "ວຽງທອງ"],
    ["ນະຄອນປາກເຊ", "ຊະນະສົມບູນ", "ສຸຂຸມາ", "ໂຂງ", "ຈຳປາສັກ", "ໂພນທອງ", "ບາຈຽງຈະເລີນສຸກ", "ປາກຊ່ອງ", "ມຸນລະປະໂມກ", "ປະທຸມພອນ"],
    ["ຊຳເໜືອ", "ຊຽງຄໍ້", "ຮ້ຽມ", "ວຽງໄຊ", "ຊຳໃຕ້", "ຫົວເມືອງ", "ສົບເບົາ", "ແອດ", "ກວັນ", "ຊອນ"],
    ["ທ່າແຂກ", "ຫີນບູນ", "ໜອງບົກ", "ເຊບັ້ງໄຟ", "ຍົມມະລາດ", "ມະຫາໄຊ", "ໄຊບົວທອງ", "ນາກາຍ", "ຄູນຄຳ", "ບົວລະພາ"],
    ["ຫຼວງນ້ຳ", "ສິງ", "ລອງ", "ວຽງພູຄາ", "ນາແລ"],
    ["ນະຄອນຫຼວງພະບາງ", "ຊຽງເງິນ", "ນານ", "ປາກອູ", "ນ້ຳບາກ", "ປາກແຊງ", "ໂພນໄຊ", "ຈອມເພັດ", "ວຽງຄຳ", "ພູຄູນ", "ໂພນທອງ", "ງອຍ"],
    ["ໄຊ", "ຫຼາ", "ນາໝໍ້", "ແບງ", "ຮຸນ", "ງາ", "ປາກແບງ"],
    ["ຜົ້ງສາລີ", "ໃໝ່", "ຂວາ", "ສຳພັນ", "ບຸນເໜືອ", "ຍອດອູ", "ບຸນໃຕ້"],
    ["ສາລະວັນ", "ຕະໂອ້ຍ", "ຕຸ້ມລານ", "ລະຄອນເພັງ", "ວາປີ", "ຄົງເຊໂດນ", "ເລົ່າງາມ", "ສະໝ້ວຍ"],
    ["ນະຄອນໄກສອນພົມວິຫານ", "ອຸທຸມພອນ", "ອາດສະພັງທອງ", "ພີນ", "ເຊໂປນ", "ນອງ", "ທ່າປາງທອງ", "ສອງຄອນ", "ຈຳພອນ", "ຊົນບູລີ", "ໄຊບູລີ", "ວິລະບູລີ", "ອາດສະພອນ", "ໄຊພູທອງ", "ພະລານໄຊ"],
    ["ລະມານ", "ກະລຶມ", "ດາກຈຶງ", "ທ່າແຕງ"],
    ["ໂພນໂຮງ", "ທຸລະຄົມ", "ແກ້ວອຸດົມ", "ກາສີ", "ວັງວຽງ", "ເຟືອງ", "ຊະນະຄາມ", "ແມດ", "ວຽງຄຳ", "ຫີນເຫີບ", "ໝື່ນ"],
    ["ສີໂຄດຕະບອງ", "ສີສັດຕະນາກ", "ໄຊທານີ", "ຈັນທະບູລີ", "ໄຊເສດຖາ", "ຫາດຊາດຟອງ", "ນາຊາຍທອງ", "ປາກງື່ມ", "ສັງທອງ"],
    ["ໄຊຍະບູລີ", "ຄອນ", "ຫົງສາ", "ເງິນ", "ຊຽງຮ່ອນ", "ພຽງ", "ປາກລາຍ", "ແກ່ນທ້າວ", "ບໍ່ແຕນ", "ທົ່ງມີໄຊ", "ໄຊສະຖານ"],
    ["ແປກ", "ຄຳ", "ໜອງແຮດ", "ຄູນ", "ໝອກ", "ພູກູດ", "ຜາໄຊ"],
    ["ອານຸວົງ", "ລ້ອງແຈ້ງ", "ທ່າໂທມ", "ຮົ່ມ", "ລ້ອງຊານ"]
  ]

  public isvending = false;
  public province_server:any=[]
  public userdata: any = []
  public user_address: any = []
  public storedetail = { profileuuid: "", storeid: "" }
  public storeID: string = ""
  public province_array=Array<IProvince>();
  public distirct_array =Array<IDistrict>();
  public village_array =Array<IVillage>();
  public dot=false;
  public currentpage='';
  public isHomePage = false;
  public loadnewfavorite = false;
  constructor() { }
}

export interface IDistrict{
  dr_id:number;
  dr_name:string;
  dr_name_en:string;
  pr_id:number;
}
export interface IVillage{
  dr_id:number;
  vill_name:string;
  vill_name_en:string;
  vill_id:number;
}
export interface IProvince{
  pr_id:number;
  pr_name:string;
  pr_name_en:string;
}

